import { render, staticRenderFns } from "./ClientProducts.vue?vue&type=template&id=24b81b2c&scoped=true&"
import script from "./ClientProducts.vue?vue&type=script&lang=js&"
export * from "./ClientProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b81b2c",
  null
  
)

export default component.exports